import React from 'react';
import { useParams } from 'react-router-dom';

import { TFunc } from '@Translations/types';
import { useGlobalization } from '@Translations/useGlobalization';
import IntegrationsViewGrid from '../components/IntegrationsViewGrid';
import ArcGisSettings from '../integrations/arcgis/ArcGisSettings/ArcGisSettings';
import ArcGisSettingsForm from '../integrations/arcgis/ArcGisSettings/ArcGisSettingsForm';
import { IntegrationStepName } from '../types/integration.types';
import IntegrationEdit from '../integrations/arcgis/ArcGisSettings/IntegrationEdit';
import VaparSettingsForm from '../integrations/vapar/VaparSettingsForm';
import VaparSettings from '../integrations/vapar/VaparSettings';
import IntegrationEditVapar from '../integrations/vapar/IntegrationEditVapar';
import ITPipesSettingsForm from '../integrations/itpipes/ITPipesSettingsForm';
import ITPipesSettings from '../integrations/itpipes/ITPipesSettings';
import IntegrationEditITPipes from '../integrations/itpipes/IntegrationEditITPipes';

function withIntegrationStepRoute(
	integrationPageName: IntegrationStepName,
	t: TFunc,
) {
	switch (integrationPageName) {
		case IntegrationStepName.ArcGisSettings:
			return (
				<ArcGisSettingsForm>
					<ArcGisSettings />
				</ArcGisSettingsForm>
			);
		case IntegrationStepName.VaparSettings:
			return (
				<VaparSettingsForm>
					<VaparSettings />
				</VaparSettingsForm>
			);
		case IntegrationStepName.ITPipesSettings:
			return (
				<ITPipesSettingsForm>
					<ITPipesSettings />
				</ITPipesSettingsForm>
			);
		case IntegrationStepName.Edit:
			return <IntegrationEdit />;
		case IntegrationStepName.EditVapar:
			return <IntegrationEditVapar />;
		case IntegrationStepName.EditITPipes:
			return <IntegrationEditITPipes />;
		case undefined:
			return <IntegrationsViewGrid />;
		default:
			return <>{t('Unable to load route')}</>;
	}
}

export default function IntegrationsViewRouter() {
	const { t } = useGlobalization();
	const params = useParams<{ integrationPageName: IntegrationStepName }>();
	return withIntegrationStepRoute(params.integrationPageName, t);
}
